import { _DICC_ALUMNO } from "../../../../data/modulo/Alumno";
import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createAlumnoProvider = (ctx: TGlobalSearchProviderContext): ISearchProvider => {
    return {
        key: "alumno",
        label: "Alumnos",
        subLabel: "Gestión de alumnos",
        action: ctx.navigateModule("alumnos/alumnos"),
        search: (query: string): ISearchResult[] => {
            const category = "Alumnos";

            return Array.from(_DICC_ALUMNO.values())
                .filter((alumno) => {
                    const fullName = `${alumno.Nombre} ${alumno.ApPaterno} ${alumno.ApMaterno}`;
                    const idValue = String(alumno.IdChild);
                    return ctx.filter(query, idValue, [fullName, category]);
                })
                .map<ISearchResult>((alumno) => ({
                    id: `alumno-${alumno.IdChild}`,
                    title: `${alumno.Nombre} ${alumno.ApPaterno} ${alumno.ApMaterno}`.trim(),
                    subtitle: `ID ${alumno.IdChild}`,
                    category,
                    action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild),
                    children: [
                        {
                            id: `alumno-${alumno.IdChild}-datosgenerales`,
                            title: "Información general",
                            category: "Datos",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnoinfogeneral"),
                        },
                        {
                            id: `alumno-${alumno.IdChild}-tutores`,
                            title: "Tutores",
                            category: "Datos",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnotutores"),
                        },
                        {
                            id: `alumno-${alumno.IdChild}-expedientes`,
                            title: "Expedientes",
                            category: "Datos",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnoexpedientes"),
                        },
                        {
                            id: `alumno-${alumno.IdChild}-horariosgrupos`,
                            title: "Horarios y grupos",
                            category: "Datos",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnohorariosgrupos"),
                        },
                        {
                            id: `alumno-${alumno.IdChild}-finanzas-cargos&descuentos`,
                            title: "Finanzas: cargos y descuentos",
                            category: "Finanzas",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnocargosdescuentos"),
                        },
                        {
                            id: `alumno-${alumno.IdChild}-finanzas-edocta`,
                            title: "Finanzas: estado de cuenta",
                            category: "Finanzas",
                            action: ctx.navigatePanel("alumnos/alumnos/panel", alumno.IdChild, "palumnoedocta"),
                        },
                    ],
                }));
        },
    };
};
